import { render, staticRenderFns } from "./eod-checkbox.vue?vue&type=template&id=5e5b2204"
import script from "./eod-checkbox.vue?vue&type=script&lang=js"
export * from "./eod-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports